import React from 'react';
import { HERO } from '../mock';

export default function Footer() {
  return (
    <footer className="relative py-24 border-t border-[color:var(--bx-gold)]/15">
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "linear-gradient(180deg, rgba(8,7,5,0.55) 0%, rgba(7,6,5,0.85) 100%)",
        }}
      />
      <div className="container-narrow text-center relative">
        <div className="font-sc text-[10px] gold-text tracking-[0.4em] mb-6">BLACK AXE · OFFICIAL POSTER</div>
        <div className="max-w-sm mx-auto relative">
          <div className="absolute -inset-3 bg-[radial-gradient(ellipse_at_center,rgba(200,161,74,0.15),transparent_70%)] blur-2xl" />
          <img src={HERO.poster} alt="BLACK AXE Poster" className="relative w-full h-auto block border border-[color:var(--bx-gold)]/30" />
        </div>
        <p className="font-serif italic text-2xl md:text-3xl mt-12 max-w-3xl mx-auto text-[color:var(--bx-bone)]">
          {HERO.tagline}
        </p>
        <div className="mt-8 inline-flex items-center gap-3">
          <span className="bullet-mark" />
          <span className="font-sc text-[11px] gold-text tracking-[0.4em]">{HERO.status}</span>
        </div>
        <div className="mt-16 pt-8 border-t border-[color:var(--bx-gold)]/10 font-sc text-[10px] text-[color:var(--bx-muted)] tracking-[0.36em]">
          © BLACK AXE — A TAMIL NOIR FEATURE · WRITTEN & DIRECTED BY ANL ARASU
        </div>
      </div>
    </footer>
  );
}
